const Loading = ({ setAvatarUrl }) => {
  return (
    <div className="flex justify-center items-center space-x-2">
      <div className="circle1 w-4 h-4 rounded-full bg-primary loader-div"></div>
      <div className="circle2 w-4 h-4 rounded-full bg-primary loader-div"></div>
      <div className="circle3 w-4 h-4 rounded-full bg-primary loader-div"></div>
    </div>
  )
}

export default Loading
